export default __webpack_public_path__ + "static/media/head03_zh_cn_sp.18b62f5a.png";